import {
    Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {ProductService} from '../../services/product.service';
import {Contract} from '../../model/Entities/Contract';
import {Filter} from '../../model/Helpers/Filter';
import {MatTableDataSource} from '@angular/material';
import {ContractItem} from '../../model/Entities/ContractItem';
import {Product} from '../../model/Entities/Product';
import {ProductContent} from '../../model/Entities/ProductContent';
import {ContractState} from '../../model/Entities/ContractState';
import {ContractItemService} from '../../services/contract-item.service';
import {VatRateService} from '../../services/vat-rate.service';
import {DialogService} from '../../services/dialog.service';
import {ContractItemType} from '../../model/Entities/ContractItemType';
import {ContractItemSplitDialogComponent} from '../ContractItemSplitDialogComponent/contract-item-split.dialog.component';
import {ProductContractItem} from '../../model/Entities/ProductContractItem';
import {DeliveryContractItem} from '../../model/Entities/DeliveryContractItem';
import {DeploymentContractItem} from '../../model/Entities/DeploymentContractItem';
import {AvailabilityService} from '../../services/availability.service';
import {Availability} from '../../model/Entities/Availability';
import {TextContractItem} from '../../model/Entities/TextContractItem';
import {
    ContractItemAvailabilityDialogComponent
} from '../ContractItemAvailabilityDialogComponent/contract-item-availability.dialog.component';
import {DragulaService} from 'ng2-dragula';
import {ProductType} from '../../model/Entities/ProductType';
import { ContractEditComponent } from '../ContractEditComponent/contract-edit.component';
import { viewParentEl } from '@angular/core/src/view/util';
import { Observable } from 'rxjs';

@Component({
    selector: 'contract-items-list',
    templateUrl: './contract-items-list.component.html',
    styleUrls: ['./contract-items-list.component.scss']
})
export class ContractItemsListComponent implements OnInit, OnDestroy, OnChanges {
    readonly contractItemTypeClass: any = ContractItemType;
    readonly contractStateClass: any = ContractState;

    @Input() contract: Contract;
    @Output() contractChange: EventEmitter<Contract> = new EventEmitter<Contract>();


    @Input() public editable = true;
    @Input() public showPrices = true;

    @ViewChild('itemsTableBody') itemsTableBody: ElementRef;

    loading: boolean = false;



    readonly editableColumns = ['itemName', 'itemCount', 'itemLentCount', 'itemPrice',
        'itemSale', 'itemVatRate', 'itemVat', 'itemTotal', 'actions'];
    // readonly readonlyColumns = ['itemName', 'itemCount', 'itemLentCount', 'itemPrice',
    //     'itemSale', 'itemVatRate', 'itemVat', 'itemTotal'];
    readonly readonlyColumnsWithState = ['itemName', 'itemCount', 'itemLentCount', 'stateCounts', 'itemPrice',
        'itemSale', 'itemVatRate', 'itemVat', 'itemTotal'];

    displayedColumns = this.editableColumns;
    itemsDataSource: MatTableDataSource<ContractItem> = new MatTableDataSource<ContractItem>([]);

    filters = {
        name: '',
        type: []
    };

    constructor(private route: ActivatedRoute,
                private router: Router,
                private contractItemService: ContractItemService,
                private productService: ProductService,
                private availabilityService: AvailabilityService,
                public vatRateService: VatRateService,
                private dialogService: DialogService,
                private snackService: SnackService,
                private dragulaService: DragulaService) {

        this.initDragulaItems();
    }

    ngOnInit(): void {
        this.reloadItemsDS();
        this.contractItemService.subscribeForChanges(this);
    }

    ngOnDestroy(): void {
        this.contractItemService.unsubscribeForChanges(this);
    }

    contractItemsChangedFromService(): void {
        this.loadContractItems(this.contract.id);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.editable) {
            this.displayedColumns = this.readonlyColumnsWithState;
        }

        if (changes.contract.previousValue !== changes.contract.currentValue
            && this.contract.id) {
            this.loadContractItems(this.contract.id);
        }
        this.reloadItemsDS();
    }

    initDragulaItems(): void {
        if (this.dragulaService.find('items-list') !== undefined) {
            this.dragulaService.destroy('items-list');
        }

        this.dragulaService.setOptions('items-list', {
            moves: function (el, container, handle) {
                return handle.className === 'handle';
            }
        });

        this.dragulaService.drag.subscribe((val) => {
            val[1].classList.add('dragging');
        });

        this.dragulaService.drop.subscribe((val) => {
            val[1].classList.remove('dragging');
            this.saveNewItemsOrder();
        });
    }

    getFilteredItems(): ContractItem[] {
        return this.itemsDataSource.data
            .filter((i: ContractItem) => {
                if (this.filters.type.length === 0) {
                    return true;
                }

                if (this.filters.type.includes('product') && i.type === ContractItemType.group) {
                    return true;
                }

                if (this.filters.type.includes('group') && i.type === ContractItemType.group) {
                    return true;
                }

                if (this.filters.type.includes('wrap') && i.isProduct() && (i as ProductContractItem).product.type === ProductType.wrap) {
                    return true;
                }

                if (this.filters.type.includes('text') && i.isText()) {
                    return true;
                }

                if (this.filters.type.includes('delivery') && i.isDelivery()) {
                    return true;
                }

                if (this.filters.type.includes('deployment') && i.isDeployment()) {
                    return true;
                }

                return false;
            })
            .filter((i: ContractItem) => {
                return this.filters.name.trim() === '' || i.name.toLocaleLowerCase().indexOf(this.filters.name.toLocaleLowerCase()) >= 0;
            });
    }

    setFilters(filters: any): void {
        this.filters = filters;
    }

    saveNewItemsOrder(): void {
        let order = 1;
        for (const child of this.itemsTableBody.nativeElement.children) {
            const ci: ContractItem = this.getContractItem(+child.dataset.itemId);

            if (ci.order !== order) {
                ci.order = order;
                this.saveContractItemUpdate(ci);
            }

            order++;
        }
    }

    private getContractItem(id: number): ContractItem {
        for (const i of this.itemsDataSource.data) {
            if (i.id === id) {
                return i;
            }
        }
        return null;
    }

    reloadItemsDS(): void {
        this.itemsDataSource = new MatTableDataSource<ContractItem>(this.contract.items.sort((a: ContractItem, b: ContractItem) => {
            return a.order - b.order;
        }));
    }

    removeItemsByType(type: ContractItemType): void {
        this.contract.items.forEach((ci: ContractItem) => {
            if (ci.type !== type) {
                return;
            }

            this.removeItem(ci);
        });
    }

    addCustomItem(name: string, type: ContractItemType = ContractItemType.other): void {
        let ci: ContractItem;
        switch (type) {
            case ContractItemType.delivery:
                ci = new DeliveryContractItem();
                ci.lentCount = 1;
                break;
            case ContractItemType.deployment:
                ci = new DeploymentContractItem();
                ci.lentCount = 1;
                break;
            case ContractItemType.text:
                ci = new TextContractItem();
                ci.name = name;
                ci.order = this.getMaxOrderNumber() + 1;
                break;
            case ContractItemType.other:
                ci = new ProductContractItem(null);
                ci.order = this.getMaxOrderNumber() + 1;
                ci.type = type;
                ci.name = name;
                break;
            default:
                return;
        }
        ci.setContract(this.contract);

        this.contractItemService.save(ci).subscribe((result: ContractItem) => {
            this.snackService.showSuccess(`Položka ${ci.name} byla přidána`);
            this.contract.items.push(result);
            this.reloadItemsDS();
        });
    }

    addItem(p: Product, count: number | null = null, order: number | null = null, duplicate: ProductContractItem | null = null): void {

        this.loading = true;
        const existingCI = duplicate != null ? null : this.getExistingContractItem(p);

        if (existingCI !== null && count) {
            existingCI.count = +existingCI.count + count;
            this.updateContractItem(existingCI);
            this.loading = false;
            return;
        } else if (existingCI !== null) {
            this.snackService.showWarn(`Položka ${p.name} již existuje - navyšte počet`);
            this.loading = false;
            return;
        }

        const ci: ProductContractItem = new ProductContractItem(p);
        ci.setContract(this.contract);
        ci.days = this.contract.daysCount;

        if (order !== null) {
            ci.order = order;
        } else {
            ci.order = this.getMaxOrderNumber() + 1;
        }

        if (count !== null) {
            ci.count = count;
            ci.lentCount = count;
        }

        ci.sale = this.contract.customer.sale;

        if (duplicate) {
            ci.name = duplicate.name;
            ci.hirePrice = duplicate.hirePrice;
            ci.lossPrice = duplicate.lossPrice;
            ci.sale = duplicate.sale;
            ci.vat = duplicate.vat;
            ci.productId = duplicate.productId;
            ci.isSell = duplicate.isSell;
            ci.isWrap = duplicate.isWrap;
            ci.type = duplicate.type;
        }

        if (p && p.type === ProductType.wrap) {
            ci.isWrap = true;
        }

        this.contractItemService.save(ci).subscribe((result: ProductContractItem) => {
            this.loading = false;
            this.snackService.showSuccess(`Položka ${ci.name} byla přidána`);
            result.product = p;
            this.contract.items.push(result);
            this.reloadItemsDS();

            // tyto typy neumeji nebo nepotrebuji pocitat dostupnost
            if (result.isLoss || result.isDeployment() || result.isDelivery() || result.isOther()) {
                return ;
            }

            if (!this.isContractLongerThanWeek()) {
                this.availabilityService.getAvailability((result as ProductContractItem), result.count,
                    this.contract.fromStart, this.contract.toEnd, this.contract).subscribe((ava: Availability) => {
                    result.availability = ava;
                });
            }

            return result;


        });
    }


    removeItem(ci: ContractItem): void {
        this.contract.items.splice(this.contract.items.indexOf(ci), 1);
        this.reloadItemsDS();
        this.contractItemService.delete(ci.id).subscribe((result) => {
            this.snackService.showSuccess(`Položka byla odstraněna`);
        });
    }

    splitItem(ci: ProductContractItem): void {
        this.dialogService.showDialog(ContractItemSplitDialogComponent, {
            'item': ci
        }, 400).afterClosed().subscribe((result: any) => {
            if (!result) {
                return;
            }

            this.splitGroup(ci);
        });
    }

    duplicateItem(ci: ProductContractItem): void {
        this.addItem(ci.product, ci.count, ci.order, ci);
    }

    toggleSell(ci: ProductContractItem): void {
        ci.isSell = !ci.isSell;
        this.saveContractItemUpdate(ci);
    }

    toggleWrapProduct(ci: ProductContractItem): void {
        ci.isWrap = !ci.isWrap;
        this.saveContractItemUpdate(ci);
    }

    public contractItemLentCountChanged($event, ci: ContractItem): void {
        ci.count = ci.lentCount;

        this.updateContractItem(ci);
    }

    public updateContractItem(ci: ContractItem): void {
        if (ci.isDelivery() || ci.isDeployment() || ci.isOther() || ci.isText()) {
            this.saveContractItemUpdate(ci);
            return;
        }

        if (this.isContractLongerThanWeek()) {
            this.saveContractItemUpdate(ci);
            return;
        }

        this.availabilityService.getAvailability((ci as ProductContractItem), ci.count,
            this.contract.fromStart, this.contract.toEnd, this.contract).subscribe((ava: Availability) => {
            ci.availability = ava;
            // if (ci.isAvailable()) {
            this.saveContractItemUpdate(ci);
            // }
        });
    }

    private getExistingContractItem(p: Product): ProductContractItem {
        for (const i of this.contract.items) {
            if (i.isDelivery() || i.isDeployment()) {
                continue;
            }

            if ((i as ProductContractItem).productId === p.id) {
                return i as ProductContractItem;
            }
        }
        return null;
    }

    private saveContractItemUpdate(ci: ContractItem): void {
        this.contractItemService.update(ci.id, ci).subscribe((result: ContractItem) => {
            this.snackService.showSuccess(`Položka ${ci.name} byla upravena`);
        });
    }

    public showAvailabilityCollisions(ci: ContractItem): void {
        this.reloadAvailability(ci);
        this.dialogService.showDialog(ContractItemAvailabilityDialogComponent, {
            'contract': this.contract,
            'contractItem': ci
        }, 1200).afterClosed().subscribe((result: any) => {
            return;
        });
    }

    public reloadAvailability(item: ContractItem = null): void {
        if (item !== null) {
            // Single item reload
            if (item.isDelivery() || item.isDeployment() || item.isOther() || item.isText()) {
                item.availability = new Availability();
                item.availability.available = null;
                return;
            }

            this.availabilityService.getAvailability((item as ProductContractItem), item.count,
                this.contract.fromStart, this.contract.toEnd, this.contract).subscribe((ava: Availability) => {
                item.availability = ava;
            });
            return;
        }

        // Batch reload pro vsechny polozky najednou (1 HTTP request)
        const productItems: ProductContractItem[] = [];
        this.contract.items.forEach((i: ContractItem) => {
            if (i.isDelivery() || i.isDeployment() || i.isOther() || i.isText()) {
                i.availability = new Availability();
                i.availability.available = null;
                return;
            }
            i.availability.available = false;
            productItems.push(i as ProductContractItem);
        });

        if (productItems.length === 0) {
            return;
        }

        const batchItems = productItems.map((i: ProductContractItem) => ({
            productId: i.productId,
            contractItemId: i.id,
            count: i.count,
        }));

        this.availabilityService.getBatchAvailability(
            batchItems, this.contract.fromStart, this.contract.toEnd, this.contract
        ).subscribe((results: any) => {
            productItems.forEach((i: ProductContractItem) => {
                if (results[i.id]) {
                    i.availability = results[i.id];
                }
            });
        });
    }

    public loadContractItems(contractId): void {
        this.contractItemService.getSimpleList(
            [new Filter('contract_id', contractId)],
            {order: 'order', expand: 'dispatched,returned,lost,product'})
            .subscribe((items: ContractItem[]) => {
                items.forEach((ci: ContractItem) => {
                    if (!ci.daysChanged) {
                        ci.days = this.contract.daysCount;
                    }
                });

                this.contract.items = items;
                this.reloadItemsDS();
                if (!this.isContractLongerThanWeek()) {
                    this.reloadAvailability();
                }
            });
    }

    private getMaxOrderNumber(): number {
        let max = 0;
        for (const i of this.contract.items) {
            if (i.isDelivery() || i.isDeployment()) {
                continue;
            }

            max = i.order > max ? i.order : max;
        }

        return max;
    }

    private splitGroup(ci: ProductContractItem) {
        this.productService.get(ci.productId, {expand: 'content'}).subscribe((p: Product) => {
            p.content.forEach((sp: ProductContent) => {
                this.addItem(sp.content, ci.count * sp.count, ci.order);
            });
            this.removeItem(ci);
            this.snackService.showSuccess(`Položka ${ci.name} byla rozdělena na jednotlivé produkty`);
        });
    }

    private isContractLongerThanWeek(): boolean {
        const from = new Date(this.contract.fromStart);
        const to = new Date(this.contract.toStart);
        const diffMs = to.getTime() - from.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        return diffDays > 7;
    }

    public selectAll($event): void {
        $event.target.select();
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractItemsListComponent/contract-items-list.component.ts